import { useState, useRef, useEffect } from "react";
import { Globe, Check } from "lucide-react";
import { LANGUAGES, useT } from "@/i18n";

export default function LanguageSwitcher({ variant = "light" }) {
  const { lang, setLang } = useT();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  const current = LANGUAGES.find((l) => l.code === lang) || LANGUAGES[0];

  useEffect(() => {
    const h = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", h);
    return () => document.removeEventListener("mousedown", h);
  }, []);

  const dark = variant === "dark";

  return (
    <div className="relative" ref={ref}>
      <button onClick={() => setOpen((o) => !o)} data-testid="language-switcher"
        className={`flex items-center gap-1.5 px-3 py-2 rounded-full text-sm font-medium transition-all ${dark ? "text-[#e6ece7] hover:bg-white/10" : "text-[#5f6b62] hover:bg-[#f4f0e8]"}`}>
        <Globe className="w-4 h-4" />
        <span>{current.flag}</span>
        <span className="hidden sm:inline">{current.label}</span>
      </button>
      {open && (
        <div className="absolute right-0 mt-2 w-52 max-h-80 overflow-y-auto bg-white rounded-xl border border-[#e5dfd3] card-shadow py-1.5 z-50" data-testid="language-menu">
          {LANGUAGES.map((l) => (
            <button key={l.code} onClick={() => { setLang(l.code); setOpen(false); }} data-testid={`lang-${l.code}`}
              className={`w-full flex items-center gap-3 px-4 py-2 text-sm hover:bg-[#f4f0e8] transition-colors ${lang === l.code ? "font-semibold text-[#1e3326]" : "text-[#5f6b62]"}`}>
              <span className="text-base">{l.flag}</span>
              <span className="flex-1 text-left">{l.label}</span>
              {lang === l.code && <Check className="w-4 h-4 text-[#d97706]" />}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
